import { actionCreator } from '@ardoq/rxbeach';

export const newFilterTerm = actionCreator<string>(
  '[test custom options] NEW_FILTER_TERM'
);

export const newOptionHovered = actionCreator<string | null>(
  '[test custom options] NEW_OPTION_HOVERED'
);

export const moveHighlightRequested = actionCreator<number>(
  '[test custom options] MOVE_HIGHLIGHT_REQUESTED'
);
// TODO remove
/*
export const modelBoxDimensionsSet = actionCreator<{
  width: number;
  maxHeight: number;
}>('[test custom options] MODEL_BOX_DIMENSIONS_SET');
*/
export const enterPressed = actionCreator<{
  nodeId?: string;
  withMetaKey: boolean;
}>('[test custom options] ENTER_PRESSED');

export const setIsSelectAll = actionCreator<boolean>(
  '[test custom options] SET_IS_SELECT_ALL'
);
